import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import dayjs from "dayjs"
import {
  GetMeterReadingsQuery,
  GetLastMeterReadingsQuery,
} from "@/api/hasura/generated/graphql"
import {
  IMeterReading,
  MeterReadingStatus,
} from "@/models/operations/meterReading/meterReading.types"
import { MeterReading } from "@/models/operations/meterReading/meterReading"

export type ILastMeterReadingRaw =
  GetLastMeterReadingsQuery["last_errored_submissions"][0] & {
    status?: MeterReadingStatus
  }

export type IMeterReadingRaw = GetMeterReadingsQuery["nova_submissions"][0] & {
  status?: MeterReadingStatus
}

export const LastMeterReadingParser: IParser<
  IMeterReading,
  ILastMeterReadingRaw
> = {
  toDomain: (data) => {
    try {
      return new MeterReading(
        data.id,
        dayjs(data.created_at),
        data.status as MeterReadingStatus,
        data.submission_values,
        data.debug_data,
        data.comment ?? "",
        data.account_number || null,
        data.user_email ?? undefined,
        data.meter_point_identifier ?? undefined,
      )
    } catch (error) {
      throw new ParseError(error)
    }
  },
}

export const MeterReadingParser: IParser<IMeterReading, IMeterReadingRaw> = {
  toDomain: (data) => {
    try {
      return new MeterReading(
        data.id,
        dayjs(data.created_at),
        data.status as MeterReadingStatus,
        data.submission_values,
        data.debug_data,
        data.comment ?? "",
        data.account_number ?? null,
        data.user_email ?? undefined,
        data.meter_point_identifier ?? undefined,
      )
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
